import * as React from 'react';
import { Modal, Button } from 'antd';
import { tokens } from 'src/design-system';

export default class InquiryDeleteModal extends React.PureComponent<any, any> {
  render() {
    const { visible, handleOk, handleCancel, isLoading } = this.props;
    return (
      <Modal
        title="Delete Inquiry"
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            No
          </Button>,
          <Button loading = {isLoading}
                key="submit"
                type="primary"
                onClick={handleOk}
                style={{ background: tokens.colors.primary, border: tokens.colors.primary }}>Yes</Button>,
        ]}
        >
        <p>Are you sure you want to delete?</p>
      </Modal>
    );
  }
}
